import {Button, Grid, Typography} from '@yandex-delivery/blocks'
import {useFormContext, useFormState} from '@yandex-delivery/form'
import React, {memo, useState} from 'react'

import type {Order} from 'src/shared/types'

import {WhatsNextModal} from '../../WhatsNextModal/WhatsNextModal'
import type {Props} from '../types'
import {useButtonTitle, useDisableReason, useNddSubmitHandler} from './hooks'
import * as classes from './SubmitButtonNdd.classes'

export const SubmitButtonNdd = memo<Props>(function SubmitButtonNdd({formRef, isLoading = false}) {
  const {control, watch} = useFormContext<Order>()
  const {isValid, isSubmitting, isValidating} = useFormState<Order>({control})
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [sharingLink, setSharingLink] = useState<string>()
  const title = useButtonTitle()
  const disableReason = useDisableReason()
  const submitHandler = useNddSubmitHandler(formRef, function successCreateOrderHandler(link?: string) {
    setIsModalVisible(true)
    setSharingLink(link)
  })

  const isClosestOfferPending = watch('nddOrder.status') === 'pending'
  const isDisabled = !isValid && disableReason
  const buttonVariant = isDisabled ? 'default' : 'action'
  const textColor = isDisabled ? 'minor' : 'main'

  return (
    <React.Fragment>
      <Button
        data-e2e="submit-button"
        loading={isSubmitting || isValidating || isLoading || isClosestOfferPending}
        onPress={submitHandler}
        size="l"
        variant={buttonVariant}
        fullWidth
      >
        <Grid alignItems="center" direction="column" container>
          <Typography color={isDisabled ? 'minor' : 'main'} Component={Grid} thickness="medium" variant="body2">
            {title}
          </Typography>
          {disableReason && (
            <Typography
              className={textColor === 'main' ? classes.subTitle : undefined}
              color={textColor}
              Component={Grid}
              variant="caption1"
            >
              {disableReason}
            </Typography>
          )}
        </Grid>
      </Button>
      {sharingLink && isModalVisible && <WhatsNextModal link={sharingLink} opened />}
    </React.Fragment>
  )
})
